import firebase from "firebase/app";
import { mapState } from "vuex";

import UsersCustomHits from '@/pages/global/components/top-bar/components/users-custom-hit/users-custom-hit.vue';
import AppDebouncedSearchBox from './components/search-custom-input/search-custom-input.vue';

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisSortBy,
    AisHitsPerPage,
} from 'vue-instantsearch';
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';


const algoliaClient = algoliasearch(
    'NFR2QQSBTT',
    '8ebc0de461fb7a818d04a848c85fad04'
);

const searchClient = {
    search(requests) {
        if (requests.every(({ params }) => !params.query)) {
            return Promise.resolve({
                results: requests.map(() => ({
                    hits: [],
                    nbHits: 0,
                    processingTimeMS: 0,
                })),
            });
        }
        return algoliaClient.search(requests);
    },
};

export default {
    data() {
        return {
            user: {},
            isLoaded: false,
            isAnonymous: true,
            language: navigator.language.split('-')[0],
            shouldLaunchSearch: true,
            searchClient,
        };
    },
    beforeCreate() {
        firebase.auth()
            .onAuthStateChanged(user => {
                this.user = user;
                this.isLoaded = true;
                if(user) this.isAnonymous = false;
            });
    },
    beforeMount() {
        this.setPageLoaded(this.$route.name.toString().toLowerCase());
    },
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisSortBy,
        AisHitsPerPage,
        UsersCustomHits,
        AppDebouncedSearchBox
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            userProfileLoaded: state => state.userProfileLoaded,
            currentUser: state => state.currentUser,
        }),
    },
    methods: {
        setPageLoaded(page) {
            this.activeTab = page;
        },
        openUrl(url) {
            window.open(url);
        },
        signoutButtonPressed(e) {
            e.stopPropagation();
            firebase.auth()
                .signOut()
                .then(() => {
                    this.$store.dispatch('user/clearData');
                    this.$router.push({ name: "Login" });
                })
                .catch((e) => {
                    console.log(e.toString());
                });
        },
        checkIfShouldSearch() {
            this.shouldLaunchSearch = true;
            console.log(this.shouldLaunchSearch);
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/global/components/top-bar/top-bar.js